module.exports = __webpack_public_path__ + "static/steuerberatung-srd-e1a5f57b76a1092c4b9a919b37ef22c7.jpg";